import React, { useState } from 'react';
import { SharedFilesUploadForm } from '../forms/SharedFilesUploadForm';
import { SonForm } from '../../../_lib/Form2';
import { Button } from '../../../components/molecules/Btn/Button';
import { BtnModifier } from '../../../components/molecules/Btn';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type SharedFilesUploadButton = {
  uploadForm: SonForm<any>;
};

/**
 * Shared files Upload Button to Open Modal with Form View.
 */
export function SharedFilesUploadButton({ uploadForm }: SharedFilesUploadButton) {
  const { t } = useSonTranslation('SharedFiles');
  const [uploadFormOpen, setUploadFormOpen] = useState<boolean>(false);

  return (
    <>
      <div>
        <Button modifier={BtnModifier.SINGLE_ACTION} type="button" onClick={() => setUploadFormOpen(true)}>
          <Button.Text>{t('forms.upload.buttonTopOpenForm')}</Button.Text>
        </Button>
      </div>
      {uploadForm && uploadFormOpen && (
        <ModalDialog
          closeModal={() => setUploadFormOpen(false)}
          headline={t('forms.upload.buttonTopOpenForm')}
          initialFocusIndex={2}
        >
          <SharedFilesUploadForm form={uploadForm} />
        </ModalDialog>
      )}
    </>
  );
}
